import { Trans } from '@tecma/i18n';

import currencyFormatter from './currencyFormatter';

export const displayPrice = (showFrequency: boolean, price: number) => (
  <Trans
    i18nKey='quote.price'
    values={{ price: currencyFormatter('EUR', price) }}
    context={showFrequency ? 'rent' : undefined}
    components={{ span: <span /> }}
  />
);
